module.exports = __webpack_public_path__ + "img/img_value.17735463.png";